/* ============================================================
   PurpleGreens® Fußnoten-Engine
   Datei: pg-footnotes.js
   Version: 1.0 — 12.05.2026
   
   Syntax im Rich-Text-Editor:
     [fn:1]           → hochgestellte ¹
     [fn:1,3,15]      → ¹·³·¹⁵
     [fn:nrv]         → hochgestelltes *  (Sonderzeichen-Fußnote)
     [fn:made]        → hochgestelltes ˟  
     [fn:nem]         → hochgestelltes ˟˟ 
     [fn:review]      → hochgestelltes ˟˟˟
   
   Am Seitenende wird automatisch ein Fußnotenblock generiert,
   der nur die tatsächlich verwendeten Fußnoten enthält.
   ============================================================ */

(function() {
  'use strict';

  // ============================================================
  // KONFIG
  // ============================================================
  
  var FN_REGEX = /\[fn:\s*([a-z0-9, ]+?)\s*\]/gi;
  var SKIP_TAGS = ['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'CODE', 'PRE', 'BUTTON'];

  // Symbol-Mapping für Sonderzeichen-Fußnoten
  var SYMBOL_DISPLAY = {
    "nrv":    "*",
    "made":   "˟",
    "nem":    "˟˟",
    "review": "˟˟˟"
  };

  // Reihenfolge im Footnote-Block
  var SYMBOL_ORDER = ["nrv", "made", "nem", "review"];

  // Hochgestellte Unicode-Ziffern
  // Hochgestellt wird via CSS gemacht (.pg-fn-ref), nicht via Unicode-Glyphs.
  // Unicode-Superscript wäre ein Mix aus U+00B9/B2/B3 (Latin-1) und U+2070ff
  // (Superscripts-Block) und in vielen Fonts unterschiedlich groß.
  function toSuper(num) {
    return String(num);
  }

  // ============================================================
  // TEIL 1: AUTO-REPLACE [fn:N] in hochgestellte Links
  // ============================================================

  // Globaler Tracker: welche Fußnoten kommen auf dieser Seite vor?
  var seenKeys = [];           // Reihenfolge des ersten Vorkommens
  var seenKeysSet = {};        // Lookup
  var refCounter = {};         // Zähler für back-refs pro Schlüssel
  var refMap = {};             // key → Array von Anker-IDs

  function registerKey(key) {
    if (!seenKeysSet[key]) {
      seenKeysSet[key] = true;
      seenKeys.push(key);
      refCounter[key] = 0;
      refMap[key] = [];
    }
  }

  function buildFootnoteLink(key) {
    // Sonderzeichen?
    var isSymbol = SYMBOL_DISPLAY.hasOwnProperty(key);
    if (!isSymbol && !window.PGFootnotesData[key]) {
      // Ungültige Fußnote → original belassen mit Warnung
      console.warn('[PG-Footnotes] Unbekannte Fußnote:', key);
      return '[fn:' + key + ']';
    }
    
    registerKey(key);
    refCounter[key]++;
    var refId = 'pg-fnref-' + key + '-' + refCounter[key];
    refMap[key].push(refId);
    
    var display = isSymbol ? SYMBOL_DISPLAY[key] : toSuper(key);
    
    return '<sup class="pg-fn-ref"><a id="' + refId + '" href="#pg-fn-' + key + '" data-pg-fn="' + key + '">' + display + '</a></sup>';
  }

  function buildMultiFootnoteHTML(keysStr) {
    // [fn:1,3,15] → mehrere Fußnoten mit Mittelpunkt-Separator
    var keys = keysStr.split(',').map(function(k) { return k.trim().toLowerCase(); }).filter(Boolean);
    if (keys.length === 1) return buildFootnoteLink(keys[0]);
    
    var parts = [];
    keys.forEach(function(key, idx) {
      var isSymbol = SYMBOL_DISPLAY.hasOwnProperty(key);
      if (!isSymbol && !window.PGFootnotesData[key]) {
        console.warn('[PG-Footnotes] Unbekannte Fußnote:', key);
        return;
      }
      registerKey(key);
      refCounter[key]++;
      var refId = 'pg-fnref-' + key + '-' + refCounter[key];
      refMap[key].push(refId);
      var display = isSymbol ? SYMBOL_DISPLAY[key] : toSuper(key);
      parts.push('<a id="' + refId + '" href="#pg-fn-' + key + '" data-pg-fn="' + key + '">' + display + '</a>');
    });
    
    return '<sup class="pg-fn-ref pg-fn-multi">' + parts.join('<span class="pg-fn-sep">·</span>') + '</sup>';
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function processTextNode(textNode) {
    var text = textNode.nodeValue;
    if (!text || text.indexOf('[fn:') === -1) return false;

    FN_REGEX.lastIndex = 0;
    if (!FN_REGEX.test(text)) return false;

    FN_REGEX.lastIndex = 0;
    var newHTML = '';
    var lastIndex = 0;
    var match;
    var replaced = false;

    while ((match = FN_REGEX.exec(text)) !== null) {
      newHTML += escapeHtml(text.substring(lastIndex, match.index));
      newHTML += buildMultiFootnoteHTML(match[1]);
      lastIndex = FN_REGEX.lastIndex;
      replaced = true;
    }
    if (!replaced) return false;
    
    newHTML += escapeHtml(text.substring(lastIndex));

    var wrapper = document.createElement('span');
    wrapper.className = 'pg-footnote-wrapper';
    wrapper.innerHTML = newHTML;
    textNode.parentNode.replaceChild(wrapper, textNode);
    return true;
  }

  function walkAndReplace(root) {
    if (!root) return;
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          if (!node.nodeValue || node.nodeValue.indexOf('[fn:') === -1) {
            return NodeFilter.FILTER_REJECT;
          }
          var parent = node.parentNode;
          while (parent && parent !== root) {
            if (SKIP_TAGS.indexOf(parent.tagName) !== -1) return NodeFilter.FILTER_REJECT;
            if (parent.classList && (parent.classList.contains('pg-footnote-wrapper') || parent.classList.contains('pg-footnotes-block'))) {
              return NodeFilter.FILTER_REJECT;
            }
            parent = parent.parentNode;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );
    var nodes = [];
    var current;
    while ((current = walker.nextNode())) nodes.push(current);
    nodes.forEach(processTextNode);
  }

  // ============================================================
  // TEIL 2: FUSSNOTENBLOCK AM SEITENENDE RENDERN
  // ============================================================

  function renderFootnoteBlock() {
    if (seenKeys.length === 0) {
      // Nichts gefunden → existierenden Block ggf. entfernen
      var old = document.getElementById('pg-footnotes-block');
      if (old) old.remove();
      return;
    }

    // Sortierung: zuerst numerische Fußnoten (in Reihenfolge des Vorkommens),
    // dann Symbol-Fußnoten in fixer Reihenfolge
    var numericKeys = seenKeys.filter(function(k) { return !SYMBOL_DISPLAY[k]; });
    var symbolKeys = SYMBOL_ORDER.filter(function(k) { return seenKeysSet[k]; });
    
    // Numerisch nach Zahl sortieren
    numericKeys.sort(function(a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    
    var orderedKeys = numericKeys.concat(symbolKeys);

    var existing = document.getElementById('pg-footnotes-block');
    if (existing) existing.remove();

    var block = document.createElement('section');
    block.id = 'pg-footnotes-block';
    block.className = 'pg-footnotes-block';
    block.setAttribute('aria-label', 'Fußnoten und Health Claims');

    var details = document.createElement('details');
    details.className = 'pg-footnotes-details';

    var summary = document.createElement('summary');
    summary.className = 'pg-footnotes-summary';
    summary.innerHTML = 'Fußnoten & Health Claims';
    details.appendChild(summary);

    var list = document.createElement('ol');
    list.className = 'pg-footnotes-list';

    orderedKeys.forEach(function(key) {
      var isSymbol = SYMBOL_DISPLAY.hasOwnProperty(key);
      var text = isSymbol ? window.PGFootnotesSymbols[key] : window.PGFootnotesData[key];
      if (!text) return;
      var marker = isSymbol ? SYMBOL_DISPLAY[key] : toSuper(key);
      
      var item = document.createElement('li');
      item.className = 'pg-footnotes-item';
      item.id = 'pg-fn-' + key;
      
      // Back-Refs zur ersten Quelle
      var backref = '';
      if (refMap[key] && refMap[key].length) {
        backref = '<a class="pg-fn-back" href="#' + refMap[key][0] + '" aria-label="Zurück zum Text">↩</a>';
      }
      
      item.innerHTML = '<span class="pg-fn-marker">' + marker + '</span> <span class="pg-fn-text">' + escapeHtml(text) + '</span> ' + backref;
      list.appendChild(item);
    });

    details.appendChild(list);
    block.appendChild(details);

    // Wo einfügen? Direkt vor dem Footer, falls vorhanden
    var insertionPoint = document.querySelector('[data-pg-footnotes]');
    if (insertionPoint) {
      insertionPoint.appendChild(block);
    } else {
      var main = document.querySelector('main, #main, [role="main"]');
      if (main) {
        main.appendChild(block);
      } else {
        document.body.appendChild(block);
      }
    }
  }

  // ============================================================
  // TEIL 3: SMOOTH-SCROLL UND HIGHLIGHT
  // ============================================================

  function bindFootnoteScrolling() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[data-pg-fn]');
      if (link) {
        e.preventDefault();
        var key = link.getAttribute('data-pg-fn');
        var target = document.getElementById('pg-fn-' + key);
        if (target) {
          // Block aufklappen, falls geschlossen
          var details = target.closest('details');
          if (details && !details.open) details.open = true;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.classList.add('is-highlighted');
          setTimeout(function() { target.classList.remove('is-highlighted'); }, 1800);
        }
        return;
      }
      var back = e.target.closest('.pg-fn-back');
      if (back) {
        e.preventDefault();
        var href = back.getAttribute('href');
        var anchor = document.querySelector(href);
        if (anchor) {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var sup = anchor.closest('.pg-fn-ref');
          if (sup) {
            sup.classList.add('is-highlighted');
            setTimeout(function() { sup.classList.remove('is-highlighted'); }, 1800);
          }
        }
      }
    });
  }

  // ============================================================
  // INIT
  // ============================================================

  function init(root) {
    // Bei jedem Init State zurücksetzen, damit nichts doppelt zählt
    seenKeys = [];
    seenKeysSet = {};
    refCounter = {};
    refMap = {};
    
    walkAndReplace(root || document.body);
    renderFootnoteBlock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      bindFootnoteScrolling();
    });
  } else {
    init();
    bindFootnoteScrolling();
  }

  document.addEventListener('shopify:section:load', function() { setTimeout(init, 50); });
  document.addEventListener('shopify:section:reorder', function() { init(); });

  window.PGFootnotes = { init: init };

})();